<template>
  <div class="question-feedback-page">
    <SubPageHeader title="问题反馈" />
    <div class="content">
      <section class="section">
        <h2 class="section-title">同志您好</h2>
        <p class="section-paragraph">
          欢迎使用天翼党建（VR版），产品正在持续迭代优化中，您使用中的任何问题和建议，欢迎第一时间与我们联系，您的宝贵意见是我们产品持续提升的动力。
        </p>
      </section>

      <section class="section">
        <h2 class="section-title">联系我们</h2>
        <p class="section-paragraph">
          您可以通过您所在支部的管理员，或以下方式与我们快速联系：
        </p>
        <ul class="contact-list">
          <li class="contact-item">· 党委管理员&nbsp;&nbsp;&nbsp;唐潇&nbsp;&nbsp;&nbsp;18918529578</li>
          <li class="contact-item">· 党委管理员&nbsp;&nbsp;&nbsp;李诗棋&nbsp;&nbsp;&nbsp;18939795771</li>
          <li class="contact-item">· 产品经理&nbsp;&nbsp;&nbsp;赵洲&nbsp;&nbsp;&nbsp;18928799480</li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../component/SubPageHeader.vue';

export default {
  name: 'QuestionFeedbackPage',
  components: {
    SubPageHeader
  }
};
</script>

<style scoped lang="scss">
.question-feedback-page {
  min-height: 100vh;
  background: #ffffff;
}

.content {
  margin: 0 3.84615vw;
  padding: 2.5641vw 1.28205vw 6.41026vw;
  background: #ffffff;
}

.section {
  padding: 5.12821vw 1.28205vw 6.41026vw;
  border-bottom: 0.25641vw solid #e4e4e4;
}

.section:last-child {
  border-bottom: none;
}

.section-title {
  margin: 0;
  font-size: 8.20513vw;
  font-weight: 700;
  color: #001a43;
  line-height: 1.2;
}

.section-paragraph {
  margin: 4.10256vw 0 0;
  font-size: 4vw;
  line-height: 1.9;
  color: #001a43;
  text-align: justify;
}

.contact-list {
  margin: 3.07692vw 0 0;
  padding: 0;
  list-style: none;
}

.contact-item {
  margin-bottom: 2.05128vw;
  font-size: 4vw;
  line-height: 1.8;
  color: #001a43;
}

.contact-item:last-child {
  margin-bottom: 0;
}
</style>
